import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getProfile, getUserData } from '../services/authService';

/**
 * Custom hook for handling user authentication
 * Eliminates code duplication across multiple pages
 */
export const useAuth = () => {
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const storedUser = getUserData();

        if (storedUser) {
          setUserData(storedUser);
          setIsLoading(false);
        } else {
          const data = await getProfile();
          setUserData(data);
          setIsLoading(false);
        }
      } catch (err) {
        console.error('Error fetching profile:', err);
        setError(err);
        setIsLoading(false);
        navigate('/login');
      }
    };

    fetchUserData();
  }, [navigate]);

  return { userData, isLoading, error };
};

